import React from 'react';

/**
 * Skeleton - Loading skeleton component
 * Provides loading placeholders
 */
export const Skeleton = ({ 
  variant = 'text', 
  className = '',
  width,
  height 
}) => {
  const baseClasses = 'animate-pulse bg-gray-200 rounded';
  
  if (variant === 'text') {
    return (
      <div 
        className={`${baseClasses} h-4 ${className}`}
        style={{ width: width || '100%' }}
      />
    );
  }
  
  if (variant === 'circle') {
    return (
      <div 
        className={`${baseClasses} rounded-full ${className}`}
        style={{ width: width || '40px', height: height || '40px' }}
      />
    );
  }
  
  if (variant === 'rect') {
    return (
      <div 
        className={`${baseClasses} ${className}`}
        style={{ width: width || '100%', height: height || '100px' }}
      />
    );
  }
  
  return null;
};

/**
 * SkeletonCard - Pre-built skeleton for cards
 */
export const SkeletonCard = () => {
  return (
    <div className="bg-white rounded-xl border border-gray-200 p-6">
      <div className="flex items-start justify-between mb-4">
        <div className="flex-1">
          <Skeleton variant="text" width="40%" className="mb-2" />
          <Skeleton variant="text" width="60%" />
        </div>
        <Skeleton variant="circle" width="48px" height="48px" />
      </div>
    </div>
  );
};

export default Skeleton;
